import en_US from './en_US.json';
import is_IS from './is_IS.json';

export const I18N_LOCALE_MAPS = { en_US, is_IS };

export type I18N = keyof typeof I18N_LOCALE_MAPS;
export const I18N_LOCALES = Object.keys(I18N_LOCALE_MAPS) as Array<I18N>;
